import { normalizeSting } from '~/modules/Songs/utils/getSongId';
import { randomInt } from '~/modules/utils/randomValue';
import songStats from '~/routes/LandingPage/songStats.json';

export default function createKaraokeAnonymousUserName() {
  const words = [...new Set(songStats.artists.flatMap((artist) => normalizeSting(artist).split('-')))].filter(
    (word) => word.length <= 10,
  );

  return new Array(randomInt(3, 5))
    .fill(0)
    .map(() => words[randomInt(0, words.length - 1)])
    .join('-');
}
